export const data = {
    name: "Disposition",
    layout: [],
};
export default data;